module.exports = __webpack_public_path__ + "img/TK스포츠.22c4d7d5.png";